import { useTranslation } from 'react-i18next';

import { routes } from 'data/routes';

import { Button } from 'components/Button';
import { Icon } from 'components/Icon';

import * as S from './NotFound.styles';

export function NotFound(): React.ReactElement {
  const { t } = useTranslation();

  return (
    <S.Container>
      <Icon name="FiAlertCircle" size={48} color="#a94442" />

      <S.Title scale="xl2" fontFamily="LFT Zeno">
        {t('order.notFound')}
      </S.Title>

      <S.Info scale="s" fontFamily="LFT Zeno" fontWeight="extraLight">
        {t('order.notFoundDescription')}
      </S.Info>

      <Button asLink to={routes.viewOrders} motive="actionTertiary" iconLeft="FiArrowLeft">
        {t('order.backToOrders')}
      </Button>
    </S.Container>
  );
}
